<div class="container" *ngIf="customerId; else missingCustomer">
    <nz-row nzJustify="center">
        <nz-col nzFlex="1">
            <textarea
                nz-input
                placeholder="Write a note..."
                [nzAutosize]="{ minRows: 3, maxRows: 10 }"
                [(ngModel)]="content"
                (ngModelChange)="contentChange.emit($event)"
            ></textarea>
        </nz-col>
    </nz-row>
    <nz-row nzJustify="space-between">
        <nz-col>
            <portals-name-avatar
                [fullName]="user ? user.firstName + ' ' + user.lastName : ''"
            ></portals-name-avatar>
        </nz-col>
        <nz-col>
            <button
                *ngIf="content !== ''"
                nz-button
                nzType="primary"
                [nzShape]="'round'"
                (click)="save()"
            >
                Save
            </button>
        </nz-col>
    </nz-row>
</div>

<ng-template #missingCustomer>
    Unable to write a note for an unknown patient.
</ng-template>
